<div class="week-days-header"
     [class.disabled]="disabled"
     [ngbPopover]="daysTpl"
     #daysPopover="ngbPopover"
     triggers="manual"
     container="body"
     placement="bottom-start bottom-end top-start top-end auto"
     autoClose="outside"
     popoverClass="working-days-popup"
     (shown)="onPopoverShown()"
     (hidden)="onPopoverHidden()">
  <!-- a11y (WCAG 2.1.1 Keyboard / 2.4.3 Focus Order / 4.1.2 Name, Role, Value):
       native button so the "Week controls" working-days trigger is keyboard
       operable. It is a real Tab stop (tabindex="0"), reached through AG Grid's
       OWN header Tab navigation — LearningCurveDialogComponent deliberately
       does NOT wire `enableGridInteractiveControlTabOrder` here, because that
       helper makes Tab visit interactive controls only and would stop keyboard
       users stepping across the editable AHT / % Productive week cells, which
       this dialog keeps on AG Grid's native cell-to-cell Tab model (see
       `defaultColDef`). Enter / Space activate it natively, and ArrowDown
       moves into the column's first body cell via
       `enableGridHeaderControlArrowNav` (ESP-18552).
       aria-haspopup / aria-expanded expose the popover state. The whole
       visible trigger (name, icon and the label link) lives INSIDE the button
       so it is all keyboard operable through the single button — the label is
       not a separate mouse-only (click) target. -->
  <button type="button"
          class="week-days-top"
          tabindex="0"
          [disabled]="disabled"
          aria-haspopup="dialog"
          [attr.aria-expanded]="daysPopover.isOpen()"
          (click)="togglePopover(daysPopover)">
    <span class="week-days-title">
      <span class="week-days-name">{{ params.displayName }}</span>
      <span class="icon-as-date week-days-icon" aria-hidden="true"></span>
    </span>
    <span class="week-days-label">{{ label }}</span>
  </button>
</div>

<ng-template #daysTpl>
  <div class="working-days-popover"
       (keydown)="onPopoverKeydown($event)">
    <div class="working-days-title">
      {{ 'learning.curve.dialog.working.days.title' | translate: { '0': weekNumber } }}
    </div>
    <div class="working-days-list">
      <!-- a11y (WCAG 2.1.1 Keyboard): the native checkbox is the interactive
           control so each day is a real Tab stop and Space toggles it. The
           label is associated via for/id so a mouse click on the day name also
           toggles it. `(change)` drives the model; `onToggle` flips the bound
           value which re-syncs [checked]. The `.checkbox` global styling draws
           the visible box from the (opacity:0) input's adjacent label:before,
           so the input MUST stay immediately before the label. -->
      <div class="checkbox" *ngFor="let item of dayCheckboxes">
        <input type="checkbox"
               [id]="'wd-' + weekKey + '-' + item.day"
               [checked]="item.checked"
               (change)="onToggle(item)">
        <label [attr.for]="'wd-' + weekKey + '-' + item.day">{{ item.labelKey | translate }}</label>
      </div>
    </div>
    <breeze-button class="apply-all-btn"
                   [isSecondary]="true"
                   [showTooltip]="false"
                   buttonText="{{ 'learning.curve.dialog.apply.to.all.weeks' | translate }}"
                   (clicked)="onApplyToAll()"></breeze-button>
  </div>
</ng-template>
